import { useParams, Link } from 'react-router';
import { getDisciplineBySlug } from '../../lib/disciplines.js';
import { getProjectsByDiscipline } from '../../lib/projects.js';
import { getAllEvents } from '../../lib/events.js';
import { useDocumentTitle } from '../../lib/useDocumentTitle.js';

export default function DisciplinePage() {
  const { slug } = useParams();
  const discipline = getDisciplineBySlug(slug);
  useDocumentTitle(discipline ? discipline.name : 'Discipline Not Found');

  if (!discipline) {
    return (
      <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
        <h1>Discipline not found</h1>
        <p>
          <Link to="/disciplines">Back to disciplines</Link>
        </p>
      </div>
    );
  }

  const projects = getProjectsByDiscipline(slug);
  const events = getAllEvents().filter((e) => e.discipline === slug);

  return (
    <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
      <p className="meta">
        <Link to="/disciplines">← Disciplines</Link>
      </p>
      <h1>{discipline.name}</h1>
      <p>{discipline.description}</p>

      <section className="section-marked" style={{ marginTop: '2rem' }}>
        <h2>Projects</h2>
        {projects.length === 0 ? (
          <p>No projects listed yet.</p>
        ) : (
          <ul className="hairline-list">
            {projects.map((p) => (
              <li key={p.slug}>
                <Link to={`/projects/${p.slug}`}>{p.title}</Link>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className="section-marked" style={{ marginTop: '2rem' }}>
        <h2>Events</h2>
        {events.length === 0 ? (
          <p>No events listed yet.</p>
        ) : (
          <ul className="hairline-list">
            {events.map((e) => (
              <li key={e.slug}>{e.title}</li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
